import { SatisfactionApi } from '@apps/surv/api/models/satisfaction-api';
import { DateTime } from 'luxon';

export class Satisfaction
{
    public satisfactionId: string;
    public entityId: string;
    public userId: string;
    public userLastFirstName: string;
    public surveyDate: DateTime;
    public salesComment: string;
    public salesEvaluation: number;
    public serviceComment: string;
    public serviceEvaluation: number;
    public sdmComment: string;
    public sdmEvaluation: number;
    public ticketingComment: string;
    public ticketingEvaluation: number;
    public bcsComment: string;
    public bcsEvaluation: number;
    public ccsComment: string;
    public ccsEvaluation: number;
    public spocComment: string;
    public spocEvaluation: number;
    public dcsComment: string;
    public dcsEvaluation: number;
    public maintenanceComment: string;
    public maintenanceEvaluation: number;
    public praComment: string;
    public praEvaluation: number;
    public adcComment: string;
    public adcEvaluation: number;
    public cs2Comment: string;
    public cs2Evaluation: number;
    public securityComment: string;
    public securityEvaluation: number;
    public npsComment: string;
    public npsEvaluation: number;

    public globalEvaluation: number;
    public warning: boolean;
}

export class DomainSatisfaction extends Satisfaction
{
    public static mapperFromApi (source: SatisfactionApi): Satisfaction
    {
        const target: Satisfaction = new Satisfaction();
        Object.assign(target, source);

        const notes = [
            target.salesEvaluation,
            target.serviceEvaluation,
            target.sdmEvaluation,
            target.ticketingEvaluation,
            target.bcsEvaluation,
            target.ccsEvaluation,
            target.spocEvaluation,
            target.dcsEvaluation,
            target.maintenanceEvaluation,
            target.praEvaluation,
            target.adcEvaluation,
            target.cs2Evaluation,
            target.securityEvaluation,
            target.npsEvaluation
        ].filter(n => n);

        target.globalEvaluation = notes.reduce((accumulator, currentValue) => accumulator + currentValue, 0) / notes.length;
        target.warning = notes.findIndex(n => n < 7) !== -1;

        return target;
    }
}
